import actions from "./actions";

const initState = {
    lockedActivationResult: [],
    loading: false,
    error: null,
    lockedDailyPlanResult: [],
    lockedSimSwapResult: [],

    realselockActivationmessage: null,
    realselockActivationerror: null,
    releaselockActivationloading: false,

    realselockDailyPlanmessage: null,
    realselockDailyPlanerror: null,
    releaselockDailyPlanloading: false,

    realselockSIMSwapmessage: null,
    realselockSIMSwaperror: null,
    releaselockSIMSwaploading: false
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_LOCKED_ACTIVATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case actions.GET_LOCKED_ACTIVATION_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lockedActivationResult: action.lockedActivationResult,
                error: null,
            };
        case actions.GET_LOCKED_ACTIVATION_REQUEST_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case actions.GET_LOCKED_DAILY_PALN_ACTIVATION:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case actions.GET_LOCKED_DAILY_PALN_ACTIVATION_SUCCESS:
            return {
                ...state,
                loading: false,
                lockedDailyPlanResult: action.lockedDailyPlanResult,
                error: null,
            };
        case actions.GET_LOCKED_DAILY_PALN_ACTIVATION_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case actions.GET_LOCKED_SIM_SWAP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case actions.GET_LOCKED_SIM_SWAP_REQUEST_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lockedSimSwapResult: action.lockedSimSwapResult,
                error: null,
            };
        case actions.GET_LOCKED_SIM_SWAP_REQUEST_REQUEST_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case actions.RELESE_ACTIVATION_REQUEST:
            return {
                ...state,
                realselockActivationmessage: null,
                realselockActivationerror: null,
                releaselockActivationloading: true,
            }
        case actions.RELESE_ACTIVATION_REQUEST_SUCCESSFUL:
            return {
                ...state,
                realselockActivationmessage: action.payload.message,
                releaselockActivationloading: false,
                realselockActivationerror: null,
            }
        case actions.RELESE_ACTIVATION_REQUEST_FAILED:
            return {
                ...state,
                realselockActivationerror: action.payload.error,
                realselockActivationmessage: null,
                releaselockActivationloading: false
            }

        case actions.RELESE_DAILY_PLAN_REQUEST:
            return {
                ...state,
                realselockDailyPlanmessage: null,
                realselockDailyPlanerror: null,
                releaselockDailyPlanloading: true

            }
        case actions.RELESE_DAILY_PLAN_REQUEST_SUCCESSFUL:
            return {
                ...state,
                realselockDailyPlanmessage: action.payload.message,
                releaselockDailyPlanloading: false,
                realselockDailyPlanerror: null,
            }
        case actions.RELESE_DAILY_PLAN_REQUEST_FAILED:
            return {
                ...state,
                realselockDailyPlanerror: action.payload.error,
                realselockDailyPlanmessage: null,
                releaselockDailyPlanloading: false
            }
        case actions.RELESE_SIM_SWAP_REQUEST:
            return {
                ...state,
                realselockSIMSwapmessage: null,
                realselockSIMSwaperror: null,
                releaselockSIMSwaploading: true
            }
        case actions.RELESE_SIM_SWAP_REQUEST_SUCCESSFUL:
            return {
                ...state,
                realselockSIMSwapmessage: action.payload.message,
                releaselockSIMSwaploading: false,
                realselockSIMSwaperror: null,
            }
        case actions.RELESE_SIM_SWAP_REQUEST_FAILED:
            return {
                ...state,
                realselockSIMSwaperror: action.payload.error,
                realselockSIMSwapmessage: null,
                releaselockSIMSwaploading: false
            }

        case actions.RESET_MESSAGE:
            return {
                ...state,
                realselockActivationmessage: null,
                realselockActivationerror: null,
                realselockDailyPlanmessage: null,
                realselockDailyPlanerror: null,
                realselockSIMSwaperror: null,
                realselockSIMSwapmessage: null,
            }
        default:
            return state;
    }
}
